import { render, staticRenderFns } from "./InfoFiles.vue?vue&type=template&id=f8921e4a&scoped=true"
import script from "./InfoFiles.vue?vue&type=script&lang=js"
export * from "./InfoFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8921e4a",
  null
  
)

export default component.exports